import { AuctionInsightKey } from '~/src/dash/apiV2/campaigns';
import { ISankeyNodeConfig } from '~/src/dash/components/charts/Sankey/common';
import { graphColors } from '~/src/dash/utils/colors';

export const campaignAuctionInsightsNodes: Record<AuctionInsightKey, ISankeyNodeConfig> = {
  TotalTargetedRequests: {
    tKey: 'TargetedRequests',
    color: graphColors.lightblue,
    order: 1,
    depth: 0, // Start
  },
  TotalAdserverFilled: {
    tKey: 'CampaignFilled',
    color: graphColors.cyan,
    order: 2,
    depth: 1,
  },
  TotalPacingRejected: {
    tKey: 'PacingRejected',
    color: graphColors.lavender,
    order: 3,
    depth: 1, // Terminates
  },
  TotalBidResponse: {
    tKey: 'BidResponses',
    color: graphColors.turquoise,
    order: 4,
    depth: 2,
  },
  TotalInvalidCreatives: {
    tKey: 'InvalidCreatives',
    color: graphColors.blueGrey,
    order: 5,
    depth: 2, // Terminates
  },
  TotalAuctionBids: {
    tKey: 'AuctionBids',
    color: graphColors.mustard,
    order: 6,
    depth: 3,
  },
  TotalBidResponseErrors: {
    tKey: 'BidResponseErrors',
    color: graphColors.palePink,
    order: 7,
    depth: 3, // Terminates
  },
  TotalNoBid: {
    tKey: 'NoBids',
    color: graphColors.paleYellow,
    order: 8,
    depth: 3, // Terminates
  },
  TotalBidTimeout: {
    tKey: 'BidTimeouts',
    color: graphColors.slateGrey,
    order: 9,
    depth: 3, // Terminates
  },
  TotalValidBids: {
    tKey: 'ValidBids',
    color: graphColors.pink,
    order: 10,
    depth: 4,
  },
  TotalInvalidBids: {
    tKey: 'InvalidBids',
    color: graphColors.purpleBlue,
    order: 11,
    depth: 4, // Terminates
  },
  TotalBidWon: {
    tKey: 'BidWon',
    color: graphColors.seaGreen,
    order: 12,
    depth: 5,
  },
  TotalBidLost: {
    tKey: 'BidLost',
    color: graphColors.coralPink,
    order: 13,
    depth: 5, // Terminates
  },
  TotalValidBidsRejected: {
    tKey: 'BidRejected',
    color: graphColors.limeGreen,
    order: 14,
    depth: 5, // Terminates
  },
  TotalBidderImpression: {
    tKey: 'Impressions',
    color: graphColors.lightOrange,
    order: 15,
    depth: 6, // Terminates
  },
  TotalBidderNoImpression: {
    tKey: 'NoImpressions',
    color: graphColors.fluorescentPink,
    order: 16,
    depth: 6, // Terminates
  },
};
